import React from "react";
import nextId from "react-id-generator";
import { Redirect, Route, Switch } from "react-router";
import ContactPersonDetails from "./ContactPersonDetails/ContactPersonDetails";
import InstitutionDetails from "./InstitutionDetails/InstitutionDetails";
import "./register-institute.style.scss";
import RISidebar from "./RISidebar/RISidebar";
export default function RegisterInstitute() {
  const [selectedStep, setSelectedStep] = React.useState(steps[0]);
  return (
    <div className="register-institute-main">
      <aside className="register-institute-sidebar-wrapper">
        <RISidebar
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          steps={steps}
        />
      </aside>
      <div className="register-institute-body-wrapper">
        <Switch>
          <Route
            path="/register-institute/details"
            render={() => (
              <InstitutionDetails
                currentRoute={() => setSelectedStep(steps[0])}
                changeRoute={()=>setSelectedStep(steps[1])}
              />
            )}
          />
          <Route
            path="/register-institute/contact"
            render={() => (
              <ContactPersonDetails
                currentRoute={() => setSelectedStep(steps[1])}
              />
            )}
          />
          <Redirect to="/register-institute/details" />
        </Switch>
      </div>
    </div>
  );
}

const steps = [
  {
    keyId: nextId(),
    number: 1,
    title: "Institute Details",
    id: "details",
  },
  {
    keyId: nextId(),
    number: 2,
    title: "Contact Person Details",
    id: "contact",
  },
];
